module.exports = {
  ...require('./strips'),
};
